module.exports = __webpack_public_path__ + "static/img/05.c95533b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/05.jpg
// module id = DIoT
// module chunks = 0